// const BASE_URL = 'http://127.0.0.1:8000/api/';
const BASE_URL = 'https://pdfapi.hitnish.com/api/';
// const BASE_URL = 'https://pdf.hitnish.com/apis/public/api/';
// const BASE_URL = 'https://tilepdf.com/Api/public/api/';

export const API_URL = {

    CATEGORY_LIST: `${BASE_URL}category`,
    CATEGORY_GET: `${BASE_URL}category/show`,
    CATEGORY_SAVE: `${BASE_URL}category/store`,
    CATEGORY_UPDATE: `${BASE_URL}category/update`,
    CATEGORY_DELETE: `${BASE_URL}category/delete`,

    SUB_CATEGORY_LIST: `${BASE_URL}sub-category`,
    SUB_CATEGORY_GET: `${BASE_URL}sub-category/show`,
    SUB_CATEGORY_SAVE: `${BASE_URL}sub-category/store`,
    SUB_CATEGORY_UPDATE: `${BASE_URL}sub-category/update`,
    SUB_CATEGORY_DELETE: `${BASE_URL}sub-category/delete`,
    ADMIN_SUB_CATEGORY_BY_CATEGORY: `${BASE_URL}category/sub-category`,

    SIZE_LIST: `${BASE_URL}size`,
    SIZE_GET: `${BASE_URL}size/show`,
    SIZE_SAVE: `${BASE_URL}size/store`,
    SIZE_UPDATE: `${BASE_URL}size/update`,
    SIZE_DELETE: `${BASE_URL}size/delete`,

    SERIES_LIST: `${BASE_URL}series`,
    SERIES_GET: `${BASE_URL}series/show`,
    SERIES_SAVE: `${BASE_URL}series/store`,
    SERIES_UPDATE: `${BASE_URL}series/update`,
    SERIES_DELETE: `${BASE_URL}series/delete`,
    SERIES_IMAGES: `${BASE_URL}series/images`,
    SERIES_SAVE_IMAGE: `${BASE_URL}series/save-image`,
    SERIES_DELETE_IMAGE: `${BASE_URL}series/delete-image`,
    SERIES_PAGE_NUMBER: `${BASE_URL}series/order-image`,

    PDF_LIST: `${BASE_URL}pdf`,
    PDF_GET: `${BASE_URL}pdf/show`,
    PDF_SAVE: `${BASE_URL}pdf/store`,
    PDF_UPDATE: `${BASE_URL}pdf/update`,
    PDF_DELETE: `${BASE_URL}pdf/delete`,

    // GRADE_LIST: `${BASE_URL}grade`,
    // GRADE_GET: `${BASE_URL}grade/show`,
    // GRADE_SAVE: `${BASE_URL}grade/store`,
    // GRADE_UPDATE: `${BASE_URL}grade/update`,
    // GRADE_DELETE: `${BASE_URL}grade/delete`,

    // TRANSPORT_LIST: `${BASE_URL}transport`,
    // TRANSPORT_GET: `${BASE_URL}transport/show`,
    // TRANSPORT_SAVE: `${BASE_URL}transport/store`,
    // TRANSPORT_UPDATE: `${BASE_URL}transport/update`,
    // TRANSPORT_DELETE: `${BASE_URL}transport/delete`,

    PARTY_LIST: `${BASE_URL}party`,
    PARTY_GET: `${BASE_URL}party/show`,
    PARTY_SAVE: `${BASE_URL}party/store`,
    PARTY_UPDATE: `${BASE_URL}party/update`,
    PARTY_DELETE: `${BASE_URL}party/delete`,

    PRODUCT_LIST: `${BASE_URL}product`,
    PRODUCT_GET: `${BASE_URL}product/show`,
    PRODUCT_SAVE: `${BASE_URL}product/store`,
    PRODUCT_UPDATE: `${BASE_URL}product/update`,
    PRODUCT_DELETE: `${BASE_URL}product/delete`,
    PRODUCT_BY_IDS: `${BASE_URL}product/by-ids`,
    PRODUCT_UPDATE_COLORS: `${BASE_URL}product/update-colors`,

    COUNTRY_LIST: `${BASE_URL}country`,
    COUNTRY_GET: `${BASE_URL}country/show`,
    COUNTRY_SAVE: `${BASE_URL}country/store`,
    COUNTRY_UPDATE: `${BASE_URL}country/update`,
    COUNTRY_DELETE: `${BASE_URL}country/delete`,

    // BANKS_LIST: `${BASE_URL}banks`,
    // BANKS_GET: `${BASE_URL}banks/show`,
    // BANKS_SAVE: `${BASE_URL}banks/store`,
    // BANKS_UPDATE: `${BASE_URL}banks/update`,
    // BANKS_DELETE: `${BASE_URL}banks/delete`,

    // SALES_RETURN_LIST: `${BASE_URL}sales-return`,
    // SALES_RETURN_SAVE: `${BASE_URL}sales-return/store`,
    // SALES_RETURN_SHOW: `${BASE_URL}sales-return/show`,
    // SALES_RETURN_DELETE: `${BASE_URL}sales-return/delete`,

    // PURCHASE_RETURN_LIST: `${BASE_URL}purchase-return`,
    // PURCHASE_RETURN_SAVE: `${BASE_URL}purchase-return/store`,
    // PURCHASE_RETURN_SHOW: `${BASE_URL}purchase-return/show`,
    // PURCHASE_RETURN_DELETE: `${BASE_URL}purchase-return/delete`,

    SETTING_SAVE: `${BASE_URL}setting/store`,
    SETTING_GET: `${BASE_URL}setting/show`,
    SETTING_PASSWORD: `${BASE_URL}setting/password`,
    LOGIN_URL: `${BASE_URL}login`,
    STATES_LIST: `${BASE_URL}states`,
    LOGIN_USER: `${BASE_URL}me`,

    // INVOICE_LIST: `${BASE_URL}sales`,
    // INVOICE_GET: `${BASE_URL}sales/show`,
    // INVOICE_SAVE: `${BASE_URL}sales/store`,
    // INVOICE_UPDATE: `${BASE_URL}sales/update`,
    // INVOICE_DELETE: `${BASE_URL}sales/delete`,

    // PURCHASE_LIST: `${BASE_URL}purchase`,
    // PURCHASE_GET: `${BASE_URL}purchase/show`,
    // PURCHASE_SAVE: `${BASE_URL}purchase/store`,
    // PURCHASE_UPDATE: `${BASE_URL}purchase/update`,
    // PURCHASE_DELETE: `${BASE_URL}purchase/delete`,

    PAYMENT_LIST: `${BASE_URL}payments`,
    PAYMENT_GET: `${BASE_URL}payments/show`,
    PAYMENT_SAVE: `${BASE_URL}payments/store`,
    PAYMENT_UPDATE: `${BASE_URL}payments/update`,
    PAYMENT_DELETE: `${BASE_URL}payments/delete`,

    LEDGER_LIST: `${BASE_URL}ledgers`,
    OUTSTANDING: `${BASE_URL}ledgers/outstanding`,

    SUB_PRODUCT_LIST: `${BASE_URL}sub-product`,
    SUB_PRODUCT_GET: `${BASE_URL}sub-product/show`,
    SUB_PRODUCT_SAVE: `${BASE_URL}sub-product/store`,
    SUB_PRODUCT_UPDATE: `${BASE_URL}sub-product/update`,
    SUB_PRODUCT_DELETE: `${BASE_URL}sub-product/delete`,

    PROFILE_LIST: `${BASE_URL}profile`,
    PROFILE_GET: `${BASE_URL}profile/show`,
    PROFILE_SAVE: `${BASE_URL}profile/store`,
    PROFILE_UPDATE: `${BASE_URL}profile/update`,
    PROFILE_DELETE: `${BASE_URL}profile/delete`,

    USER_LIST: `${BASE_URL}users`,
    USER_GET: `${BASE_URL}users/show`,
    USER_SAVE: `${BASE_URL}users/store`,
    USER_UPDATE: `${BASE_URL}users/update`,
    USER_DELETE: `${BASE_URL}users/delete`,

    ROLES_LIST: `${BASE_URL}roles`,
}

